import type {TicketSummary} from './api';
export function ticketLabel(ticket:Pick<TicketSummary,'number'|'title'>):string {
  const number=ticket.number;
  const humanNumber=number&&!/^[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(number);
  return `${humanNumber?`№ ${number} · `:''}${ticket.title?.trim()||'Заявка без названия'}`;
}
